module.exports = __webpack_public_path__ + "fonts/iconfont.533416e.woff2";